import { createSelector } from 'reselect'
import getStaticPaymentScheduleOptions from './getStaticPaymentScheduleOptions'

const getPaymentScheduleRequestInfo = createSelector(
  getStaticPaymentScheduleOptions,
  (state: App.State) => state.checkout.payment.selectedStaticScheduleOptionId,
  (options, selectedId): App.Checkout.PaymentScheduleRequestInfo | null => {
    if (!selectedId) return null
    const selected = options.find(o => o.id === selectedId)
    return selected?.requestInfo ?? null
  },
)

export default getPaymentScheduleRequestInfo
